var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2204_4209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2204_4209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 12.4615V3.53851C2.33337 3.2071 2.45138 2.92339 2.68739 2.68739C2.92339 2.45138 3.2071 2.33337 3.53851 2.33337H12.4615C12.793 2.33337 13.0767 2.45138 13.3127 2.68739C13.5487 2.92339 13.6667 3.2071 13.6667 3.53851V12.4615C13.6667 12.793 13.5487 13.0767 13.3127 13.3127C13.0767 13.5487 12.793 13.6667 12.4615 13.6667H3.53851C3.2071 13.6667 2.92339 13.5487 2.68739 13.3127C2.45138 13.0767 2.33337 12.793 2.33337 12.4615ZM3.33336 6.05131H12.6667V3.53851C12.6667 3.47867 12.6475 3.42952 12.609 3.39106C12.5705 3.35259 12.5214 3.33336 12.4615 3.33336H3.53851C3.47867 3.33336 3.42952 3.35259 3.39106 3.39106C3.35259 3.42952 3.33336 3.47867 3.33336 3.53851V6.05131ZM6.77437 9.35901H9.22567V7.05129H6.77437V9.35901ZM6.77437 12.6667H9.22567V10.359H6.77437V12.6667ZM3.33336 9.35901H5.77441V7.05129H3.33336V9.35901ZM10.2256 9.35901H12.6667V7.05129H10.2256V9.35901ZM3.53851 12.6667H5.77441V10.359H3.33336V12.4615C3.33336 12.5214 3.35259 12.5705 3.39106 12.609C3.42952 12.6475 3.47867 12.6667 3.53851 12.6667ZM10.2256 12.6667H12.4615C12.5214 12.6667 12.5705 12.6475 12.609 12.609C12.6475 12.5705 12.6667 12.5214 12.6667 12.4615V10.359H10.2256V12.6667Z",
    fill: "#2E2F32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.2b96cf88acd317c573b2c720f30cc56e.svg";
export { ForwardRef as ReactComponent };